import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="terms-and-condition container">
      <h1>Terms And Conditions</h1>
      <div className="mt-3 mb-5">
        <p>
          By using Socius, you agree to comply with our Terms & Conditions. If you do not agree, please refrain from using our services.
        </p>
        <br />

        <h5>1. User Registration & Accounts</h5>
        <p>
          • Users must provide <b>accurate and complete information</b> when creating an account.<br />
          • You are responsible for keeping your login credentials confidential.<br />
          • Unauthorized access or misuse of an account is strictly prohibited.
        </p>
        <br />

        <h5>2. Relationship Hub & AI Usage</h5>
        <p>
          • Users can create custom contact profiles, link notes, and manage relationship dates.<br />
          • AI-generated summaries and suggested touchpoints are for assistant purposes only; you remain in full control of your relationships and data.<br />
          • Any recording or transcription must be done with appropriate consent.
        </p>
        <br />

        <h5>3. Subscription & In-App Purchases</h5>
        <p>
          • Premium relationship management features may require a paid subscription.<br />
          • Fees are subject to local app store terms and billing cycles.<br />
          • Refund policies are determined by the App Store or Google Play Store controls.
        </p>
        <br />

        <h5>4. Data Privacy & Storage</h5>
        <p>
          • Socius provides privacy-first controls, keeping your relationship history secure.<br />
          • You decide how your contact notes, files, and transcripts are stored.<br />
          • Encryption and secure protocols are employed to protect sensitive details.
        </p>
        <br />

        <h5>5. Data Portability & Export</h5>
        <p>
          • Users can export their relationship records and notes at any time.<br />
          • You can delete your profile, which will purge your records from our databases in accordance with our Privacy Policy.
        </p>
        <br />

        <h5>6. Privacy & Security</h5>
        <p>
          • User data is <b>encrypted and securely stored.</b><br />
          • We do not sell or share personal contact information with third parties without consent.
        </p>
        <br />

        <h5>7. Account Suspension & Termination</h5>
        <p>
          • Accounts may be suspended for <b>fraudulent activity, policy violations, or misuse.</b><br />
          • Disputes should be resolved through <b>customer support or arbitration.</b>
        </p>
        <br />

        <h5>8. Changes to Terms</h5>
        <p>
          We may update these <b>Terms & Conditions</b> at any time. Continued use of our platform after changes are made signifies your acceptance.
        </p>
        <br />

        <h5>For inquiries or support!</h5>
        <p>
          Please contact us at support@socius.app.
        </p>
      </div>
    </div>
  );
};

export { TermsAndConditions };
